import PropTypes from 'prop-types'
import { Component } from 'react'
import ReactDOM from 'react-dom'
import { FormattedMessage } from 'react-intl'

import { Button, Icon } from './Components'
import messages from './messages'

export default class HoverMenu extends Component<any, any> {
  static propTypes = {
    value: PropTypes.string,
    placeholder: PropTypes.string,
    onSubmit: PropTypes.func,
    innerRef: PropTypes.func,
    className: PropTypes.string,
    showUrlNote: PropTypes.bool
  }

  static defaultProps = {
    value: '',
    placeholder: '',
    onSubmit: () => {},
    innerRef: () => {},
    className: '',
    showUrlNote: false
  }

  input: any
  menu: any

  constructor(props: any) {
    super(props)
    this.state = { value: props.value || '' }
  }

  componentDidUpdate(prevProps: any) {
    if (prevProps.value !== this.props.value) {
      this.setState({ value: this.props.value })
    }
  }

  menuRef = (menu: any) => {
    this.menu = menu
  }

  inputRef = (input: any) => {
    this.input = input
  }

  onChange = (event: any) => {
    this.setState({ value: event.target.value })
  }

  onKeyDown = (e: any) => {
    if (e.keyCode === 13) {
      e.preventDefault()
      e.stopPropagation()
      this.onSubmit()
    }
  }

  onSubmit = () => {
    try {
      new window.URL(this.state.value)
      decodeURIComponent(this.state.value)
      this.props.onSubmit(this.state.value)
    } catch {
      this.setState({ showError: true })
    }
  }

  focus = () => {
    this.input.focus()
  }

  getInnerRef = () => {
    return this.menu
  }

  render() {
    const { className, placeholder } = this.props
    const { value, showError } = this.state

    //hover has to be on the root or it wont work
    const root = document.querySelector('#root')

    return ReactDOM.createPortal(
      <div className={`hover-menu ${className || ''}`} ref={this.menuRef}>
        <div className="input-wrapper">
          <input
            ref={this.inputRef}
            type="text"
            placeholder={placeholder}
            value={value}
            onChange={this.onChange}
            onKeyDown={this.onKeyDown}
          />
          <Button onClick={this.onSubmit}>
            <Icon className="submit" />
          </Button>
        </div>
        {showError && (
          <div className="input-validation">
            <FormattedMessage {...messages.urlNote} />
          </div>
        )}
      </div>,
      // @ts-expect-error
      root
    )
  }
}
